/**
 * angular production environment configuration
 */
export const environment = {
	production: true,
	envName: 'production'
};